<script setup lang="ts">
import { watchImmediate } from '@vueuse/core'
import { logTime } from '@/core/utils'
import { useIdleToMain } from './IdleToMain'
import IdleTimeout from '../common/IdleTimeout.vue'

const { isActivated, debugging, timeout , doTimeout } = useIdleToMain()

watchImmediate(isActivated, (isActivatedValue) => {
  if (debugging.value) {
    if (isActivatedValue) {
      console.debug('#overview', 'idle-start', 'toMain', timeout.value, logTime())
    } else {
      console.debug('#overview', 'idle-stop', 'toMain', logTime())
    }
  }
})

function handleIdleTimeout(event: any) {
  if (debugging.value) {
    console.debug('#overview', 'idle-timeout', 'toMain', logTime())
  }
  doTimeout()
}
</script>

<template>
  <idle-timeout v-if="isActivated" :timeout @idle-timeout="handleIdleTimeout" />
</template>
